{
  "RESET_PASSWORD": {
    "TITLE": "إعادة تعيين كلمة المرور",
    "DESCRIPTION": "أدخل عنوان البريد الإلكتروني الذي تستخدمه لتسجيل الدخول إلى مركز الاتصال للحصول على تعليمات إعادة تعيين كلمة المرور.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "البريد الإلكتروني",
      "PLACEHOLDER": "الرجاء إدخال بريدك الإلكتروني.",
      "ERROR": "الرجاء إدخال بريد إلكتروني صالح."
    },
    "API": {
      "SUCCESS_MESSAGE": "تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني.",
      "ERROR_MESSAGE": "تعذر الاتصال بالخادم، الرجاء المحاولة مرة أخرى لاحقاً"
    },
    "SUBMIT": "إرسال"
  }
}
